import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c270346"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ion-padding wrapper" }


export default /*#__PURE__*/_defineComponent({
  __name: 'EmptyState',
  props: {
    icon: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("i", {
      class: _normalizeClass(["fa-light fa-lg fa-fw", [_ctx.icon]])
    }, null, 2),
    _createElementVNode("p", null, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createTextVNode(" This is empty... ")
      ])
    ])
  ]))
}
}

})